import React from 'react';
import ReactDOM from 'react-dom';
import CustomerFormButton from './CustomerFormButton.jsx';
import OrderForm from './OrderForm.jsx';
import ShipmentButtons from './ShipmentButtons.jsx';
import StockManagerContextProvider from './StockManagerContext.jsx';
import MyOrdersButton from './MyOrdersButton.jsx';
import MyProntoOrdersButton from './MyProntoOrdersButton.jsx';
import CurrentUserInfo from './CurrentUserInfo.jsx';

if ( document.getElementById('StockManagerComponents') ) {

    ReactDOM.render(<StockManagerContextProvider getMethods={methods => window.StockManagerContext = methods}>
        <OrderForm getMethods={methods => window.OrderForm = methods} />
        <ShipmentButtons getMethods={methods => window.OrderButtons = methods} />
        <CustomerFormButton startVisible={window.dev === true} />
        <MyOrdersButton  />
        <MyProntoOrdersButton  />
        <CurrentUserInfo />
    </StockManagerContextProvider>, document.getElementById('StockManagerComponents'));

}